export default __webpack_public_path__ + "12a4b3f08bd5144218598e6314afb66f.svg";